import StorageUtil from './storageUtil';
import CommonUtil from './utility';
import ViewUtility from './viewUtility';

export const AuthService = {
    isAuthenticated() {
        return StorageUtil.getData(ViewUtility.SECURITY_TOKEN);
    },
    getUserData() {
        const user = StorageUtil.getData(ViewUtility.USER_DATA);
        if (CommonUtil.isNotNull(user)) {
            return JSON.parse(user);
        }
        return null;
    },
    
    logout(cb) {
    }
};
export default AuthService;